import React, { useRef, useEffect } from 'react';
import { Box, Button, IconButton, Typography } from '@mui/material';
import { AutoAwesomeOutlined, Close as CloseIcon } from '@mui/icons-material';
import { motion } from 'framer-motion';
import StarRating from '../StarComponents/StarRating';

interface MobileFeedbackProps {
  questions: string[];
  ratings: Array<number | null>;
  handleRatingChange: (index: number, value: number | null) => void;
  handleSubmit: () => void;
  onClose: () => void; 
}

const MobileFeedback: React.FC<MobileFeedbackProps> = ({ questions, ratings, handleRatingChange, handleSubmit, onClose }) => {
  const feedbackRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (feedbackRef.current && !feedbackRef.current.contains(event.target as Node)) {
        onClose(); 
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  return (
    <motion.div
      initial={{ y: 100 }}
      transition={{ duration: 1 }}
      whileInView={{ y: 0 }}
      style={{
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0 2vh',
        width: '100vw',
      }}
    >
      <Box
        ref={feedbackRef}
        p={3}
        borderRadius={1}
        bgcolor={"white"}
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap={0}
        maxWidth="600px"
        position="relative"
      >
        <IconButton
          onClick={onClose} 
          sx={{ position: 'absolute', top: 5, right: 5, p: 1 }}
        >
          <CloseIcon />
        </IconButton>
        {questions.map((question, index) => (
          <Box key={index} mb={0.5} textAlign="center" width="100%">
            <Typography variant="body2" mb={0}>
              {question}
            </Typography>
            <StarRating
              rating={ratings[index]}
              onChange={(value) => handleRatingChange(index, value)}
            />
          </Box>
        ))}
        <Box mt={0}>
          <Button
            variant="outlined"
            sx={{
              backgroundColor: 'white',
              border: '2px solid rgb(67, 131, 186)',
              color: 'black',
              padding: 0,
              '&:hover': {
                background: "linear-gradient(to right, #04A05F 40%, #0D8C8D 60%, #1879BB 100%)",
                color: 'white'
              },
            }}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </motion.div>
  );
};

export default MobileFeedback;
